import React from 'react';
import moment from 'moment-timezone';
import { flowRight as compose } from 'lodash';
import { inject, observer } from 'mobx-react';
import { Box } from '@mui/material';
import { styled, useTheme } from '@mui/material/styles';

import acl from 'constants/acl';
import { getStyles, Item, Circle, Text } from './styles';

const ScrollableContainer = styled(Box)(({ theme }) => ({
  overflowY: 'auto',
  maxHeight: 120,
  marginTop: 10,
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: theme.palette.color.grayMain,
    border: '1px solid transparent',
    borderRadius: '4px',
  },
  '&::-webkit-scrollbar': {
    width: '5px',
  },
  '&::-webkit-scrollbar-track': {
    backgroundColor: theme.palette.color.white,
  },
}));

function NoteContent(props) {
  const theme = useTheme();
  const styles = getStyles(theme);
  const { notes, addFnc, editFnc, isEnableEdit, title, store } = props;
  const { permissionStore } = store;
  const isDenied = permissionStore.isDenied(acl.ASSIGNMENTS.NOTE);

  if (notes.length === 0) {
    return (
      <div style={styles.contentWrapper}>
        <span style={styles.showLink} onClick={addFnc}>
          + {title}
        </span>
      </div>
    );
  }

  return (
    <div style={styles.noteWrapper}>
      <div style={styles.contentWrapper}>
        <div style={styles.header}>
          <span style={{ ...styles.showLink, ...{ cursor: 'default' } }}>{title}:</span>
          {!isDenied && (
            <div style={styles.btnWrapper}>
              <button style={styles.editBtn} onClick={addFnc}>
                Add
              </button>
              {isEnableEdit && (
                <button style={styles.editBtn} onClick={editFnc}>
                  Edit
                </button>
              )}
            </div>
          )}
        </div>
        <ScrollableContainer>
          {notes.map((note, i) => {
            const username = (note.subject.attributes?.username) || '';
            return (
              <Item key={`note-item-${i}`}>
                <Circle />
                <Text>{note.content}</Text>
                <i style={styles.date}>
                  {moment(note.ts).format('M/D/YYYY H:mm')} - by {username}
                </i>
              </Item>
            );
          })}
        </ScrollableContainer>
      </div>
    </div>
  );
}

export default compose(inject('store'), observer)(NoteContent);
